import { render, staticRenderFns } from "./-FMBackUp20240805.vue?vue&type=template&id=f9cbc610&scoped=true"
import script from "./-FMBackUp20240805.vue?vue&type=script&lang=js"
export * from "./-FMBackUp20240805.vue?vue&type=script&lang=js"
import style0 from "./-FMBackUp20240805.vue?vue&type=style&index=0&id=f9cbc610&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cbc610",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9cbc610')) {
      api.createRecord('f9cbc610', component.options)
    } else {
      api.reload('f9cbc610', component.options)
    }
    module.hot.accept("./-FMBackUp20240805.vue?vue&type=template&id=f9cbc610&scoped=true", function () {
      api.rerender('f9cbc610', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinancialManagementNew/-FMBackUp20240805.vue"
export default component.exports